/**
 * 激活im会话
 * @returns {Promise}
 */
export function activateConversation(data) {
  return ZP.Ajax({
    url: '/api/message/manage/custom/active',
    data,
  });
}
